import React from "react";
import ReactDOM from "react-dom/client";
import App from "@/App";
import "@/shell/design-system.css";

const rootElement = document.getElementById("root");
if (rootElement === null) {
    throw new Error("Root element #root not found");
}
rootElement.style.minHeight = "100vh";

const root = ReactDOM.createRoot(rootElement);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);